// HandleLabReportPrint.js
//
// Same pattern as your existing HandlePrintReport.js (open a blank window,
// write a shell doc into it, mount a React root into #print-root, wait a
// beat, then print) — but this one mounts LabReportPrintReport, which
// renders the FULL list of tests as one merged document instead of a single
// test. Calling window.print() once inside LabReportPrintReport therefore
// prints every test's page in a single job, as requested.

import { createRoot } from "react-dom/client";
import LabReportPrintReport from "./LabReportPrintReport";

// reportsData: array built by buildPrintDataList() (LabReportLayoutUtils.js)
// patientDTO / bookingDTO: shared across every page in the merged document
const HandleLabReportPrint = (reportsData, patientDTO, bookingDTO) => {
  const printWindow = window.open("", "_blank", "width=900,height=700");

  if (printWindow) {
    printWindow.document.write(`
      <html>
        <head>
          <title>Lab Report Print</title>
          <style>
            body { margin: 0; font-family: 'Segoe UI', Arial, sans-serif; }
            @media print { body { margin: 0; } }
          </style>
        </head>
        <body>
          <div id="print-root"></div>
        </body>
      </html>
    `);
    printWindow.document.close();

    setTimeout(() => {
      const rootDiv = printWindow.document.getElementById("print-root");
      if (rootDiv) {
        const root = createRoot(rootDiv);
        root.render(
          <LabReportPrintReport
            reportsData={reportsData}
            patientDTO={patientDTO}
            bookingDTO={bookingDTO}
            printWindow={printWindow}
          />
        );
      }
    }, 300);
  }
};

export default HandleLabReportPrint;